// extracted by mini-css-extract-plugin
export var card = "_8y-0";
export var expandedCard = "_8y-2";
export var paginated = "_8y-1";